// Note: "label" for multiple choice cannot contain "-"

export const RegionalClassificationOptions = [
    {
        label: "Chinese Speaking Regions (华语地区)",
        children: [
            { label: "Mandarin Music (国语音乐)" },
            { label: "Cantonese Music (粤语音乐)" },
            { label: "Hokkien Music (闽南语音乐)" },
            { label: "Hakka Music (客家话音乐)" },
            { label: "Mongolian Music (蒙古族音乐)" },
            { label: "Uygur Music (新疆维族音乐)" },
            { label: "Tibetan Music (藏族音乐)" },
            { label: "Southwestern China (中国西南地区)" },
            { label: "Northwest China (中国西北地区)" },
            { label: "North China (中国华北地区)" },
            { label: "East China (中国江南/华东地区)" },
            { label: "Northeast China (中国东北地区)" },
            { label: "Central China (中国华中地区)" },
        ]
    },
    {
        label: "Europe and the U.S. (欧美地区)",
        children: [
            { label: "United States (美国)" },
            { label: "United Kingdom (英国)" },
            { label: "Germany (德国)" },
            { label: "France (法国)" },
            { label: "Italy (意大利)" },
            { label: "Russia (俄罗斯)" },
            { label: "Spain (西班牙)" },
            { label: "Portugal (葡萄牙)" },
            { label: "Northern Europe (北欧)" },
            { label: "Eastern Europe (东欧)" },
        ]
    },
    {
        label: "East Asia (东亚地区)",
        children: [
            { label: "Japan (日本)" },
            { label: "South Korea (韩国)" },
        ]
    },
    {
        label: "Southeast Asia (东南亚地区)",
        children: [
            { label: "Vietnam (越南)" },
            { label: "Thailand (泰国)" },
            { label: "Philippines (菲律宾)" },
            { label: "Cambodia (柬埔寨)" },
            { label: "Malaysia (马来西亚)" },
            { label: "Indonesia (印度尼西亚)" },
        ]
    },
    {
        label: "South Asia (南亚地区)",
        children: [
            { label: "Pakistan (巴基斯坦)" },
            { label: "India (印度)" },
            { label: "Sri Lanka (斯里兰卡)" },
        ]
    },
    {
        label: "Central Asia (中亚地区)"
    },
    {
        label: "Western Asia (西亚地区)",
    },
    {
       label: "Africa (非洲地区)",
        children: [
            { label: "North Africa (北非)" },
            { label: "West Africa (西非)" },
            { label: "Central Africa (非洲中部)" },
            { label: "East Africa (东非)" },
            { label: "Southern Africa (非洲南部)" },
        ]
    },
    {
        label: "Latin America (拉丁美洲地区)",
        children: [
            { label: "Mexico (墨西哥)" },
            { label: "Jamaica (牙买加)" },
            { label: "Brazil (巴西)" },
            { label: "Argentina (阿根廷)" },
            { label: "Cuba (古巴)" },
        ]
    },
    {
        label: "Oceania (大洋洲地区)",
    },
    {
        label: "Other Regions (其他地区)"
    }
]

const MusicStyleOptions = [
    {
        label: "布鲁斯 Blues",
        children: [
            {label: "三角洲布鲁斯 Delta Blues"},
            {label: "德克萨斯布鲁斯 Texas Blues"},
            {label: "芝加哥布鲁斯 Chicago Blues"},
            {label: "布鲁斯摇滚 Blues Rock"},
            {label: "英国布鲁斯 British Blues"},
            {
                label: "其他 Others",
                children:[
                    {label: "东海岸布鲁斯 East Coast Blues"},
                    {label: "电声布鲁斯 Electric Blues"},
                    {label: "电声德克萨斯布鲁斯 Electric Texas Blues"},
                    {label: "原声布鲁斯 Acoustic Blues"},
                    {label: "爵士布鲁斯 Jazz Blues"},
                    {label: "灵魂布鲁斯 Soul Blues"},
                    {label: "当代布鲁斯 Contemporary Blues"},
                    {label: "布吉乌吉 Boogie Woogie"},
                ]
            }
        ]
    },
    {
        label: "乡村 Country",
        children: [
            {label: "西部摇摆 Western Swing"},
            {label: "蓝草 Bluegrass"},
            {label: "纳什维尔之声 Nashville Sound"},
            {label: "乡村摇滚 Country Rock"},
            {label: "乡村流行 Country Pop"},
            {
                label: "其他 Others",
                children: [
                    {label: "传统乡村 Traditional Country"},
                    {label: "乡村布吉 Country Boogie"},
                    {label: "前卫乡村 Progressive Country"},
                    {label: "前卫蓝草 Progressive Bluegrass"},
                    {label: "叛道乡村 Outlaw Country"},
                    {label: "当代乡村 Contemporary Country"},
                    {label: "当代蓝草 Contemporary Bluegrass"},
                    {label: "另类乡村 Alt-Country"},
                    {label: "乡村民谣 Country Folk"},
                    {label: "美式乡村 Americana"},
                    {label: "牛仔 Cowboy"},
                    {label: "传统蓝草 Traditional Bluegrass"},
                    {label: "乡村福音 Country Gospel"},
                    {label: "都市牛仔 Urban Cowboy"},
                    {label: "新原音 New Acoustic"},
                    {label: "器乐乡村 Instrumental Country"},
                ]
            },

        ]
    },
    {
        label: "爵士 Jazz",
        children: [
            {label: "新奥尔良爵士 New Orleans Jazz"},
            {label: "大乐队 Big Band"},
            {label: "摇摆乐 Swing"},
            {label: "波普 Bop"},
            {label: "冷爵士 Cool Jazz"},
            {label: "巴萨诺瓦 Bossa Nova"},
            {label: "后波普 Post-Bop"},
            {label: "酸性爵士 Acid Jazz"},
            {
                label: "其他 Others",
                children:[
                    {label: "吉普赛爵士 Gypsy Jazz"},
                    {label: "非洲古巴爵士 Afro-Cuban Jazz"},
                    {label: "噪音爵士 Skiffle"},
                    {label: "第三流派 Third Stream"},
                    {label: "调式爵士 Modal Jazz"},
                    {label: "硬波普 Hard Bop"},
                    {label: "实验大乐队 Experimental Big Band"},
                    {label: "自由爵士 Free Jazz"},
                    {label: "先锋爵士 Avant-Garde Jazz"},
                    {label: "灵魂爵士 Soul Jazz"},
                    {label: "爵士流行 Jazz Pop"},
                    {label: "融合爵士 Jazz Fusion"},
                    {label: "爵士放克 Jazz Funk"},
                    {label: "柔顺爵士 Smooth Jazz"},
                    {label: "电爵士 Nu Jazz"},
                    {label: "人声爵士 Vocal Jazz"},
                    {label: "室内爵士 Chamber Jazz"},
                    {label: "当代爵士 Contemporary Jazz"},
                    {label: "拉格泰姆 Ragtime"},
                    {label: "迪克西兰爵士 Dixieland"},
                    {label: "爵士钢琴 Stride Piano"},
                    {label: "主流爵士 Mainstream Jazz"},
                    {label: "非洲爵士 African Jazz"},
                ]
            }
        ]
    },
    {
        label: "摇滚 Rock",
        children: [
            {label: "布鲁斯摇滚 Blues Rock"},
            {label: "冲浪摇滚 Surf Rock"},
            {label: "车库摇滚 Garage Rock"},
            {label: "迷幻摇滚 Psychedelic Rock"},
            {label: "硬摇滚 Hard Rock"},
            {label: "前卫摇滚 Progressive Rock"},
            {label: "艺术摇滚 Art Rock"},
            {label: "实验摇滚 Experimental Rock"},
            {label: "民谣摇滚 Folk Rock"},
            {label: "流行摇滚 Pop Rock"},
            {label: "华丽摇滚 Glam Rock"},
            {label: "独立摇滚 Indie Rock"},
            {label: "另类摇滚 Alternative Rock"},
            {label: "英伦摇滚 Britpop"},
            {label: "后摇 Post-Rock"},
            {
                label: "其他 Others",
                children: [
                    {label: "山区乡村摇滚 Rockabilly"},
                    {label: "默西之声 Merseybeat"},
                    {label: "先锋前卫摇滚 Avant-Prog"},
                    {label: "巴洛克流行 Baroque Pop"},
                    {label: "布吉摇滚 Boogie Rock"},
                    {label: "酸性摇滚 Acid Rock"},
                    {label: "电力流行 Power Pop"},
                    {label: "轻摇滚 Soft Rock"},
                    {label: "爵士摇滚 Jazz Rock"},
                    {label: "太空摇滚 Space Rock"},
                    {label: "德国前卫摇滚 Krautrock"},
                    {label: "新迷幻 Neo-Psychedelia"},
                    {label: "工业摇滚 Industrial Rock"},
                    {label: "基督摇滚 Christian Rock"},
                    {label: "日本摇滚 J-Rock"},
                    {label: "新浪漫 New Romantic"},
                    {label: "暗潮 Dark Wave"},
                    {label: "仙音 Ethereal Wave"},
                    {label: "学院摇滚 College Rock"},
                    {label: "噪音摇滚 Noise Rock"},
                    {label: "垃圾摇滚 Grunge"},
                    {label: "数学摇滚 Math Rock"},
                    {label: "自赏 Shoegazing"},
                    {label: "视觉摇滚 Visual Rock"},
                    {label: "曼彻斯特音乐 Madchester"},
                    {label: "根源摇滚 Roots Rock"},
                    {label: "中国摇滚 Chinese Rock"},
                    {label: "慢核 Slowcore"},
                    {label: "后垃圾摇滚 Post-Grunge"},
                    {label: "后英伦 Post-Britpop"},
                    {label: "车库摇滚复兴 Garage Rock Revival"},
                    {label: "低保真 Lo-Fi"},
                    {label: "说唱摇滚 Rap Rock"},
                    {label: "喜剧摇滚 Comedy Rock"},
                    {label: "石人摇滚 Stoner Rock"},
                    {label: "凯尔特摇滚 Celtic Rock"},
                    {label: "原声摇滚 Acoustic Rock"},
                    {label: "悲核 Sadcore"},
                    {label: "器乐摇滚 Instrumental Rock"},
                    {label: "沼泽摇滚 Swamp Pop"},
                    {label: "成人另类 Adult Alternative"},
                    {label: "钢琴摇滚 Piano Rock"},
                    {label: "日本摇滚 J-Rock"}
                ]
            }
        ]
    },
    {
        label: "节奏布鲁斯 R&B",
        children: [
            {label: "嘟喔普 Doo Wop"},
            {label: "灵魂乐 Soul"},
            {label: "摩城 Motown"},
            {label: "放克 Funk"},
            {label: "当代节奏布鲁斯 Contemporary R&B"},
            {label: "新灵魂乐 Neo-Soul"},
            {label: "其他 Others",
                children: [
                    {label: "流行灵魂乐 Pop Soul"},
                    {label: "乡村灵魂乐 Country Soul"},
                    {label: "南方灵魂乐 Southern Soul"},
                    {label: "白人灵魂乐 Blue Eyed Soul"},
                    {label: "北方灵魂乐 Northern Soul"},
                    {label: "深度灵魂乐 Deep Soul"},
                    {label: "芝加哥灵魂乐 Chicago Soul"},
                    {label: "迷幻灵魂乐 Psychedelic Soul"},
                    {label: "柔顺灵魂乐 Smooth Soul"},
                    {label: "P放克 P-Funk"},
                    {label: "平静风暴 Quiet Storm"},
                    {label: "都市音乐 Urban"},
                    {label: "新杰克摇摆乐 New Jack Swing"},
                    {label: "另类节奏布鲁斯 Alternative R&B"},
                    {label: "合成器放克 Synth Funk"},
                    {label: "非洲放克 Afro-Funk"},
                    {label: "新奥尔良R&B New Orleans R&b"},
                    {label: "费城灵魂乐 Philly Soul"},
                    {label: "走走放克 Go-Go"},
                    {label: "孟菲斯灵魂乐 Memphis Soul"},
                    {label: "深度放克 Deep Funk"},
                    {label: "深度放克复兴 Deep Funk Revival"},

                ]
            }
        ]
    },
    {
        label: "朋克 Punk",
        children: [
            {label: "原型朋克 Proto-Punk"},
            {label: "后朋克 Post-Punk"},
            {label: "硬核朋克 Hardcore Punk"},
            {   
                label: "其他 Others",
                children: [
                    {label: "新浪潮 New Wave"},
                    {label: "合成器朋克 Synth Punk"},
                    {label: "哥特摇滚 Gothic Rock"},
                    {label: "现代主义复兴 Mod Revival"},
                    {label: "无浪潮 No Wave"},
                    {label: "舞曲朋克 Dance-Punk"},
                    {label: "冷潮 Coldwave"},
                    {label: "流行朋克 Pop Punk"},
                    {label: "朋克俱乐部 Psychobilly"},
                    {label: "滑板朋克 Skate Punk"},
                    {label: "车库朋克 Garage Punk"},
                    {label: "后硬核 Post-Hardcore"},
                    {label: "情绪硬核 Emo"},
                    {label: "金属核 Metalcore"},
                    {label: "情绪核 Screamo"},
                    {label: "后朋复兴 Post-Punk Revival"},
                    {label: "电子核 Electronicore"},
                ]
            }
        ]
    },
    {
        label: "金属 Metal",
        children: [
            {label: "重金属 Heavy Metal"},
            {label: "激流金属 Thrash Metal"},
            {label: "厄运金属 Doom Metal"},
            {label: "黑金属 Black Metal"},
            {label: "速度金属 Speed Metal"},
            {label: "工业金属 Industrial Metal"},
            {label: "新古典金属 Neo-Classical Metal"},
            {label: "华丽金属 Glam Metal"},
            {label: "能量金属 Power Metal"},
            {label: "死亡金属 Death Metal"},
            {label: "碾核 Grindcore"},
            {
                label: "其他 Others",
                children: [
                    {label: "另类金属 Alternative Metal"},
                    {label: "前卫金属 Progressive Metal"},
                    {label: "放克金属 Funk Metal"},
                    {label: "朋克金属 Punk Metal"},
                    {label: "石人金属 Stoner Metal"},
                    {label: "维京金属 Viking Metal"},
                    {label: "律动金属 Groove Metal"},
                    {label: "技术死亡金属 Technical Death Metal"},
                    {label: "民谣金属 Folk Metal"},
                    {label: "旋律死亡金属 Melodic Death Metal"},
                    {label: "哥特金属 Gothic Metal"},
                    {label: "泥浆金属 Sludge Metal"},
                    {label: "残忍死亡金属 Brutal Death Metal"},
                    {label: "新金属 Nu Metal"},
                    {label: "交响金属 Symphonic Metal"},
                    {label: "氛围黑金属 Atmospheric Black Metal"},
                    {label: "蜂鸣金属 Drone Metal"},
                    {label: "自赏黑 Blackgaze"},
                    {label: "电子金属 / 科幻金属 Cyber Metal"},
                    {label: "说唱金属 Rap Metal"},
                    {label: "基督金属 Christian Metal"},
                    {label: "不列颠金属新浪潮 New Wave Of British Heavy Metal"},
                    {label: "自杀黑金属 Depressive Black Metal"},
                    {label: "旋律黑金 Melodic Black Metal"},
                    {label: "死亡摇滚 Death n'Roll"},
                    {label: "死碾 Deathgrind"},
                    {label: "死亡厄运金属 Death Doom Metal"},
                    {label: "葬礼厄运金属 Funeral Doom Metal"},
                    {label: "凯尔特金属 Celtic Metal"},
                    {label: "中世纪民谣金属 Medieval Folk Metal"},
                    {label: "血碾 Goregrind"},
                    {label: "电子碾 Cybergrind"},
                    {label: "氛围泥浆金属 Atmospheric Sludge Metal"},
                    {label: "先锋金属 Avant-Garde Metal"},
                    {label: "死核 Deathcore"},
                    {label: "数学金属 Djent / Math Metal"},
                ]
            }
        ]
    },
    {
        label: "民谣 Folk",
        children: [
            {label: "传统民谣 Traditional Folk"},
            {label: "当代民谣 Contemporary Folk"},
            {label: "城市民谣 Urban Folk"},
            {label: "其他 Others",
                children: [
                    {label: "苏格兰民谣 Scottish Folk"},
                    {label: "凯尔特民谣 Celtic Folk"},
                    {label: "爱尔兰民谣 Irish Folk"},
                    {label: "民谣流行 Folk Pop"},
                    {label: "室内民谣 Chamber Folk"},
                    {label: "前卫民谣 Progressive Folk"},
                    {label: "新民谣 Neofolk"},
                    {label: "迷幻民谣 Psychedelic Folk"},
                    {label: "校园民谣 Campus Folk"},
                    {label: "中世纪民谣 Medieval Folk"},
                    {label: "独立民谣 Indie Folk"},
                    {label: "反民谣 Anti-Folk"},
                    {label: "新传统主义民谣 Neo-Traditional Folk"},
                    {label: "黑暗民谣 Dark Folk"},
                    {label: "先锋民谣 Avant-Folk"},
                    {label: "中东民谣 Middle Eastern Folk"},
                    {label: "瑞典民谣 Swedish Folk"},
                    {label: "奇幻民谣 Freak Folk"},
                ]
            }
        ]
    },
    {
        label: "雷鬼 Reggae",
        children: [
            {label: "斯卡 Ska"},
            {label: "洛克斯代迪 Rocksteady"},
            {label: "回响 Dub"},
            {label: "根源雷鬼 Roots Reggae"},
            {label: "舞厅 Dancehall"},
            {label: "雷吉顿 Reggaeton"},
            {
                label: "其他 Others",
                children: [
                    {label: "雷鬼流行 Reggae Pop"},
                    {label: "雷嘎 Ragga"},
                    {label: "迪杰 Deejay / Toasting"},
                    {label: "当代雷鬼 Contemporary Reggae"},
                    {label: "Moombahton / Tresillo / Dembow"},
                ]
            }
        ]
    },
    {
        label: "嘻哈 Hip Hop",
        children: [
            {label: "东岸说唱 East Coast Hip Hop"},
            {label: "老派说唱 Old-school Hip Hop"},
            {label: "蹦啪说唱 Boom Bap"},
            {label: "西岸说唱 West Coast Hip Hop"},
            {label: "硬核说唱 Hardcore Hip Hop"},
            {label: "南方说唱 Southern Hip Hop"},
            {label: "陷阱说唱 Trap Rap"},
            {
                label: "其他 Others",
                children: [
                    {label: "意识说唱 Conscious Hip Hop"},
                    {label: "流行说唱 Pop Rap"},
                    {label: "说唱浩室 Hip House"},
                    {label: "另类说唱 Alternative Hip Hop"},
                    {label: "喜剧说唱 Comedy Hip Hop"},
                    {label: "英伦说唱 British Hip Hop"},
                    {label: "爵士嘻哈 Jazz Hip Hop"},
                    {label: "实验说唱 Experimental Hip Hop"},
                    {label: "中西部说唱 Midwest Hip Hop"},
                    {label: "地下说唱 Underground Hip Hop"},
                    {label: "法国说唱 French Hip Hop"},
                    {label: "基督教说唱 Christian Hip Hop"},
                    {label: "弛放节拍 Chill Beats"},
                    {label: "器乐嘻哈 Instrumental Hip Hop"},
                    {label: "云雾说唱 Cloud Rap"},
                    {label: "拉丁说唱 Latin Rap"},
                ]
            },
        ]
    },
    {
        label: "世界音乐 World Music",
        children: [
            {label: "西班 | 弗拉门戈 Flamenco"},
            {label: "巴基斯坦 | 卡瓦里 Qawwali"},
            {label: "葡萄牙 | 法朵 Fado"},
            {label: "古巴 | 颂乐 Son"},
            {label: "巴西 | 桑巴 Samba"},
            {label: "福音 Gospel"},
            {label: "日本 | 演歌 Enka"},
            {label: "巴西 | 全域音乐 MPB"},
            {label: "非洲打击乐 Afrobeat"},
            {label: "印度 | 邦拉 Bhangra"},
            {
                label: "其他 Others",
                children: [
                    {label: "日本 | 邦乐 Japanese Traditional Music"},
                    {label: "日本 | 雅乐 Gagaku"},
                    {label: "格里高利圣咏 Gregorian chant"},
                    {label: "蒙古 | 呼麦 Throat Singing"},
                    {label: "印度 | 拉格 Raga"},
                    {label: "韩国传统音乐 Korean Traditional Music"},
                    {label: "法国 | 香颂 Chanson"},
                    {label: "多米尼加 | 默朗格 Merengue"},
                    {label: "加勒比 | 卡吕普索 Calypso"},
                    {label: "韩国 | 演歌 Korea Trot"},
                    {label: "日本 | 岛呗 Shima Uta"},
                    {label: "犹太 | 克莱兹梅尔 Klezmer"},
                    {label: "世界节拍 Worldbeat"},
                    {label: "犹太音乐 Jewish Music"},
                    {label: "美国 | 凯金 Cajun"},
                    {label: "美国 | 柴迪科舞曲 Zydeco"},
                    {label: "墨西哥音乐 Regional Mexican"},
                    {label: "世界融合 World Fusion"},
                ]
            }
        ]
    },
    {
        label: "古典 Classical",
        children: [
            {label: "卡农曲 Canon"},
            {label: "赋格曲 Fugue"},
            {label: "变奏曲 Variation"},
            {label: "进行曲 March"},
            {label: "奏鸣曲 Sonata"},
            {label: "协奏曲 Concerto"},
            {label: "圆舞曲 Waltz"},
            {label: "前奏曲 Prelude"},
            {label: "波尔卡 Polka"},
            {label: "组曲 Suite"},
            {label: "叙事曲 Ballad"},
            {label: "夜曲 Nocturne"},
            {label: "狂想曲 Rhapsody"},
            {label: "序曲 Overture"},
            {label: "交响曲 Symphony"},
            {label: "谐谑曲 Scherzo"},
            {
                label: "其他 Others",
                children: [
                    {label: "创意曲 Invention"},
                    {label: "小步舞曲 Minuet"},
                    {label: "练习曲 Etude"},
                    {label: "即兴曲 Impromptu"},
                    {label: "回旋曲 Rondo"},
                    {label: "无词歌 Song Without Words"},
                    {label: "玛祖卡 Mazurka"},
                    {label: "波罗乃兹 Polonaise"},
                    {label: "间奏曲 Intermezzo"},
                    {label: "交响诗 Symphonic Poem"},
                    {label: "随想曲 Capriccio"},
                    {label: "幻想曲 Fantasia"},
                    {label: "浪漫曲 Romance"},
                    {label: "托卡塔 Toccata"},
                    {label: "萨拉班德 Sarabande"},
                    {label: "塔兰泰拉 Tarantella"},
                    {label: "小夜曲 Serenade"},
                    {label: "摇篮曲 Lullaby"},
                    {label: "加沃特 Gavotte"},
                    {label: "吉格 Gigue"},
                    {label: "帕凡舞曲 Pavane"},
                    {label: "库朗特 Courant"},
                    {label: "阿勒曼德 Allemande"},
                ]
            }
        ]
    },
    {
        label: "流行 Pop",
        children: [
            {label: "情歌 Ballad"},
            {label: "情歌R&B R&B Ballad"},
            {label: "中国风R&B Chinese Guofeng R&B"},
            {label: "电子R&B Electronic R&B Pop"},
            {label: "说唱R&B Rap R&B Pop"},
            {label: "流行摇滚 Rock Pop"},
            {label: "流行爵士 Jazz Pop"},
            {label: "古风 Chinese Gufeng"},
            {label: "儿歌 Children's Songs"},
            {label: "红歌/红色流行/主旋律歌曲 Red Songs / Red Pop"},
            {label: "抖音/网络神曲 TikTok/Internet Pop"},
            {label: "韩国流行音乐 K-Pop"},
            {label: "日本流行音乐 J-Pop"},
        ]
    },
    {
        label: "电子 Electronic",
        children: [
            {label: "电子舞曲 EDM/Electronic Dance Music"},
            {label: "未来贝斯 Future Bass"},
            {label: "浩室舞曲 House"},
            {label: "合成器流行 Synthpop"},
            {label: "回响贝斯 Dubstep"},
            {label: "陷阱舞曲 Trap"},
            {label: "出神舞曲 Trance"},
            {label: "科技舞曲 Techno"},
            {label: "氛围音乐 Ambient"},
            {label: "鼓打贝斯 Drum & Bass"},
            {label: "碎拍 Breakbeat"},
            {label: "蒸汽波 Vaporwave"},
            {label: "迪斯科 Disco"},
            {label: "深浩室舞曲 Deep House"},
            {label: "智能舞曲 IDM"},
            {label: "酸性浩室舞曲 Acid House"},
            {label: "底特律科技舞曲 Detroit Techno"},
            {label: "Future Kawaii"},
            {label: "Future Bounce"},
            {
                label: "其他 Others",
                children: [
                    {label: "独立电子乐 Indietronica"},
                    {label: "前卫浩室 Progressive House"},
                    {label: "电气浩室 Electro House"},
                    {label: "热带浩室 Tropical House"},
                    {label: "未来浩室 Future House"},
                    {label: "蒙巴顿舞曲 Moombahton"},
                    {label: "弛放 Chillout"},
                    {label: "复合电气 Complextro"},
                    {label: "英国车库舞曲 UK Garage"},
                    {label: "泡泡糖贝斯 Bubblegum Bass"},
                    {label: "缓拍 Downtempo"},
                    {label: "电子民谣 Folktronica"},
                    {label: "后回响重拍 Brostep"},
                    {label: "神游舞曲 Trip Hop"},
                    {label: "脉冲流行 GlitchHop"},
                    {label: "未来车库舞曲 Future Garage"},
                    {label: "氛围科技舞曲 Ambient Techno"},
                    {label: "氛围回响 Ambient Dub"},
                    {label: "大节拍 Big Beat"},
                    {label: "恍惚嘻哈舞曲 Wonky"},
                    {label: "黑暗氛围 Dark Ambient"},
                    {label: "寒潮 Chillwave"},
                    {label: "芝加哥浩室舞曲 Chicago House"},
                    {label: "氛围浩室舞曲 Ambient House"},
                    {label: "另类舞曲 Alternative Dance"},
                    {label: "脉冲 Glitch"},
                    {label: "高能量迪斯科 Hi-NRG"},
                    {label: "微声 Microsound"},
                    {label: "硬派舞曲 Hardstyle"},
                    {label: "极简科技舞曲 Minimal Techno"},
                    {label: "极简潮 Minimal Wave"},
                    {label: "科技浩室 Tech House"},
                    {label: "女巫浩室 Witch House"},
                    {label: "前卫迷幻舞曲 Progressive Trance"},
                    {label: "即兴舞曲 Freestyle"},
                    {label: "欧陆舞曲 Euro-Dance"},
                    {label: "锐舞音乐 Rave Music"},
                    {label: "新拍 New Beat"},
                    {label: "硬核科技舞曲 Hardcore Techno"},
                    {label: "工业舞曲 Industrial Dance"},
                    {label: "放克电子 Electro(Electro-Funk)"},
                    {label: "部族浩室舞曲 Tribal House"},
                    {label: "迷幻科技舞曲 Acid Techno"},
                    {label: "旋律回响贝斯 Melodic Dubstep"},
                    {label: "炸房浩室 Big Room House"},
                    {label: "贝斯浩室 Bass House"},
                    {label: "电科技舞曲 Electro-Techno"},
                    {label: "电子乐 Electronica"},
                    {label: "能量电子 Power Electronics"},
                    {label: "放克打击乐 Funky Breaks"},
                    {label: "极端科技舞曲 Gabber"},
                    {label: "快乐硬核 Happy Hardcore"},
                    {label: "二步舞曲 2-Step"},
                    {label: "解构俱乐部舞曲 Deconstructed Club"},
                    {label: "工业音乐 Industrial Music"},
                    {label: "果阿迷幻舞曲 Goa Trance"},
                    {label: "电工业舞曲 Electro-Industrial"},
                    {label: "钻击贝斯 Drill'n'BasS"},
                    {label: "病态氛围 Libient"},
                    {label: "回响科技舞曲 Dub Techno"},
                    {label: "芯片音乐 Chiptune"},
                    {label: "微浩室舞曲 Microhouse"},
                    {label: "污垢舞曲 Grime"},
                    {label: "电子行为舞曲 EBM"},
                    {label: "新迪斯科 Nu-Disco"},
                    {label: "后迪斯科 Post-Disco"},
                    {label: "迷幻氛围 Psybient"},
                    {label: "步法舞曲 Footwork"},
                    {label: "后回响贝斯 Post-Dubstep"},
                    {label: "英国放克舞曲 UK Funky"},
                    {label: "前卫电子 Progressive Electronic"},
                    {label: "极简合成器 Minimal Synth"},
                    {label: "实验回响 Experimental Dub"},
                    {label: "英国贝斯舞曲 UK Bass"},
                    {label: "工业科技舞曲 Industrial Techno"},
                    {label: "合成器潮 Synthwave"},
                    {label: "柏林学派 Berlin School"},
                    {label: "电子迪斯科 Electro-Disco"},
                    {label: "未来流行 Futurepop"},
                ]
            }
        ]
    },
    {
        label: "配乐/背景音乐 Background Music",
        children: [
            {label: "电影配乐 Movie Soundtrack"},
            {label: "电视配乐 TV Soundtrack"},
            {label: "卡通音乐 Cartoon Music"},
            {label: "日漫音乐 Anime Music"},
            {label: "游戏配乐 Video Game Music"},
        ]
    },
    {
        label: "中国戏曲 Chinese Opera",
        children: [
            {label: "京剧 Beijing Opera"},
            {label: "豫剧 Henan Opera"},
            {label: "越剧 Yue Opera"},
            {label: "评剧 Ping Opera"},
            {label: "黄梅戏 Huangmei Opera"},
        ]
    },
    {
        label: "中国民族音乐 Chinese Ethnic Music",
        children: [
            {label: "新疆地区音乐 Xinjiang Regional Music"},
            {label: "藏族音乐 Tibetan Music"},
            {label: "蒙古族音乐 Mongolian Music"},
            {label: "西南少数民族音乐 Chinese Southwest Ethnic Music"},
            {label: "西北民歌 Chinese Northwest Folk Music"},
            {label: "华北民歌 North China Folk Music"},
            {label: "江南民歌 Chinese Jiangnan Folk Music"},
            {label: "其他民族音乐 Other Traditional Chinese Folk"},
        ]
    },
    {
        label: "歌剧 Opera",
        children: [
            {label: "正歌剧 Opera Seria"},
            {label: "抒情悲剧 Tragedie Lyrique"},
            {label: "喜歌剧 Opera Buffa"},
            {label: "大歌剧 Grand Opera"},
            {label: "抒情歌剧 Opera Lyrique"},
            {label: "轻歌剧 Operetta"},
            {label: "总体艺术 Gesamtkunstwerk"},
        ]
    },
    {
        label: "音乐剧 Musical Theater",
    },
    {
        label: "合唱 Choral Music",
    },
    {
        label: "阿卡贝拉 A cappella",
    },
    {
        label: "实验 Experimental",
    },
    {
        label: "拉丁 Latin",
    },
    {
        label: "新世纪 New Age",
    }
]

const YearPubOptions = [
    { label: 'Ancient Greece (古希腊)'},
    { label: 'Ancient Roman (古罗马)'},
    { label: 'Middle Ages (中世纪)'},
    { label: 'Renaissance (文艺复兴)'},
    { label: 'Baroque Period (巴洛克时期)'},
    { label: 'The Classical Period (古典主义时期)'},
    { label: 'The Romantic Period (浪漫主义时期)'},
    { label: '1900'},
    { label: '1910'},
    { label: '1920'},
    { label: '1930'},
    { label: '1940'},
    { label: '1950'},
    { label: '1960'},
    { label: '1970'},
    { label: '1980'},
    { label: '1990'},
    { label: '2000'},
    { label: '2010'},
    { label: '2020'},
]

export const SongLevelAttributes = {
    "Basic Information": [
    // Line 1: original_filename, displayed_filename
    {
        name: "original_filename",
        questionText: "Original Filename (原文件名)",
        type: "free-response",
        mandatory: true,
        readOnly: true,
        instruction: `由制作人、MIDI 文件收集者或数据集创建者指定的原始文件名。
        Original filename assigned by the producer, the MIDI file collector, or the dataset creator.`,
    },
    {
        name: "displayed_filename",
        questionText: "Displayed Filename (显示的现文件名)",
        type: "free-response",
        mandatory: true,
        readOnly: true,
        instruction: `我们重新命名了一些冗长或复杂的文件名（例如像"adbsahdsaj"这样的随机字符串），以提高这些文件名对于标注者来说的清晰度和可识别性。此处所展示的为现文件名, 也是标注数据集中目前所显示的文件名。
        We have renamed some verbose or complex filenames (e.g., random strings like 'adbsahdsaj') to improve clarity and recognizability for the annotator. This field shows the current filename as it appears in the annotation dataset.`,
    },
    // Line 2: file_path
    {
        name: "file_path",
        questionText: "File Path (文件路径)",
        type: "free-response",
        mandatory: true,
        readOnly: true,
        fullWidth: true,
        instruction: `所标注的文件相对于标注数据集根目录的相对路径。标注者可据此找到对应文件。
        The relative path of the annotated file from the root directory of the annotation dataset, specifying its location within the dataset's folder structure.`,
    },
    // Line 3: song_title, artist
    {
        name: "song_title",
        questionText: "Song Title (歌名)",
        type: "free-response",
        instruction: `可以使用听歌识曲
        You can use "Shazam" (or "song recognition")`,
    },
    {
        name: "artist",
        questionText: "Artist (歌手)",
        type: "free-response",
        instruction: `- 可以使用听歌识曲或者在网上搜索
流行音乐才需要填这道题，纯音乐不需要填这道题，而应该填作曲家那道题
- You can use Shazam or search online.
This field is only required for pop music. For instrumental tracks, skip it and fill in the composer's section instead.`,
    },
    // Line 4: lyricist, songwriter
    { 
        name: "lyricist",
        questionText: "Lyricist (作词人)",
        type: "free-response",
        instruction: `- 可以使用听歌识曲或者在网上搜索
流行音乐才需要填这道题，纯音乐不需要填这道题，而应该填作曲家那道题
- You can use Shazam or search online.
This field is only required for pop music. For instrumental tracks, skip it and fill in the composer's section instead.`,
    },
    {
        name: "songwriter",
        questionText: "Songwriter (作曲人)",
        type: "free-response",
        instruction: `- 可以使用听歌识曲或者在网上搜索
流行音乐才需要填这道题，纯音乐不需要填这道题，而应该填作曲家那道题
- You can use Shazam or search online.
This field is only required for pop music. For instrumental tracks, skip it and fill in the composer's section instead.`,
    },
    // Line 5: arranger, composer
    {
        name: "arranger",
        questionText: "Arranger (编曲人)",
        type: "free-response",
        instruction: `- 可以使用听歌识曲或者在网上搜索
- 流行音乐才需要填这道题，纯音乐不需要填这道题，而应该填作曲家那道题
欧美流行音乐中，您很有可能找不到"编曲人"，因为他们往往会将编曲人也统称作曲人。您不用怀疑自己，可以直接不填写
- You can use Shazam or search online.
- This field is only required for pop music. For instrumental tracks, skip it and fill in the composer's section instead.
In Western pop music, arrangers are often grouped with songwriters, so you may not be able to find an explicit arranger. If unsure leave this field blank`,
    },
    {
        name: "composer",
        questionText: "Composer (作曲家)",
        type: "free-response",
        instruction: `- 只有纯音乐才需要填这道题
可以使用听歌识曲或者在网上搜索
- This field is only required for instrumental music.
You can use Shazam or search online.`,
    },
    // Line 6: duration_time_length, year_of_publication
    {
        name: "duration_time_length",
        questionText: "Duration - Time Length (歌曲时长 - 分钟数)",
        type: "time-length",
    },
    {
        name: "year_of_publication",
        questionText: "Year of Publication (歌曲年代)",
        type: "multiple-choice",
        items: YearPubOptions,
        singleSelect: true,
        instruction: `可以使用听歌识曲或者在网上搜索
You can use Shazam or search online.`,
    },
    // Line 7: presence_of_main_melody, music_type
    {
        name: "presence_of_main_melody",
        questionText: "Presence of Main Melody (是否存在主旋律)",
        type: "multiple-choice",
        items: [
            { label: "Accompaniment Only (纯伴奏)" },
            { label: "Main Melody + Accompaniment (主旋律 + 伴奏)"},
        ],
        singleSelect: true,
        mandatory: true,
        instruction: `- 当您听见的这段音乐中存在一个乐器明显在起到演奏主旋律的作用，或者虽然是由不同乐器但确实可以听到一条主旋律时，则可以选择"主旋律+伴奏"
如果您听到的这段音乐并没有主旋律，甚至您可以判断其大概率是个起到伴奏作用的音乐（而实际上应有的主旋律并没有在音频中出现）时，可以选择"纯伴奏"
- If the music contains a clear instrumental melody or a distinct melodic line played by multiple instruments, select "Main Melody + Accompaniment"
If the music has no discernible melody or is like meant to be a backing track with the melody missing, select "Accompaniment Only"`,
    },
    {
        name: "music_type",
        questionText: "Music Type (音乐类型)",
        type: "multiple-choice",
        items: [
            { label: "Instrumental Music (纯音乐)" },
            { label: "Vocal Music (含人声音乐)" },
        ],
        singleSelect: true,
        instruction: `此处的有没有人声并不是指您听没听见"人声"，因为您大概率不会在这些音频中听到人声。事实上，我们想要得到的是这是不是一首本应有人声的歌。
        This field is not about whether you "hear" a human voice. Instead, you need to consider whether the song is inherently meant to have vocals with it or not.`
    },
    {
        name: "duration_number_of_bars",
        questionText: "Duration - Number of Bars (歌曲时长 - 小节数)",
        type: "positive-integer",
        instruction: `此处的小节数应包括歌曲开头可能存在的空拍/空小节。例如，如果歌曲的第一个音从第 3 小节开始，则前两小节仍需计入总小节数。请在编曲软件中打开文件，直接查看整首音乐的最后一小节的小节数编号 以确认正确的小节数。
        The bar count here should include any empty bars that may exist at the beginning of the song. For example, if the first note of the song starts in bar 3, the first two bars should still be included in the total bar count. Please open the file in your DAW (Digital Audio Workstation) and directly check the bar number of the last measure to confirm the correct total bar count.`,
    },
    // {
    //     name: "duration_time_length",
    //     questionText: "Duration - Time Length (歌曲时长 - 分钟数)",
    //     type: "time-length",
    // },
    // Line 8: music_compositional_craftsmanship, music_completeness
    {
        name: "music_compositional_craftsmanship",
        questionText: "Music Compositional Craftsmanship\n(音乐写作水平)",
        type: "multiple-choice",
        items: [
            { label: "1" },
            { label: "2" },
            { label: "3" },
            { label: "4" },
            { label: "5" },
        ],
        instruction: `这首歌的综合写作质量在您看来和商业发型作品有多少差距(只考虑编曲部分，不考虑乐器音色和混音)?
                    1: 明显不悦耳。
                    2: 音乐爱好者/音乐作业水平。
                    3: 平庸的出版水平(和声、节奏、配器、旋律均十分简单粗糙)。
                    4: 出版水平(和声、节奏、配器、旋律均达到主流歌发行平均质量)。
                    5: 优质出版作品(和声、节奏、配器、旋律有至少1-2两项有极高的商业水准和写作手法)。
                    Evaluate the compositional quality of the music, excluding instrument quality and sound mixing
                    1: Clearly unpleasant to listen to.
                    2: At the level of a music amateur or a school music assignment.
                    3: Mediocre publishing quality (harmony, rhythm, instrumentation, and melody are all very basic and rough).
                    4: Standard publishing quality (harmony, rhythm, instrumentation, and melody meet the average quality of mainstream song releases).
                    5: High-quality commercial release (at least 1–2 elements among harmony, rhythm, instrumentation, or melody exhibit a high level of commercial polish and advanced composition techniques).
                    `,
        singleSelect: true,
        mandatory: true,
    },
    {
        name: "music_completeness",
        questionText: "Music Completeness (音乐完整度)                  ",
        type: "multiple-choice",
        items: [
            { label: "1" },
            { label: "2" },
            { label: "3" },
            { label: "4" },
            { label: "5" },
        ],
        instruction: `请您从编曲轨道完整度角度，评估该歌曲与商业发行完整版的差距。（仅考虑编曲，不涉及乐器音色和混音。）由于预处理阶段我们已删除大量轨道，请判断剩余轨道是否足以构成一首“可独立存在的完整歌曲”。原则上，无法构成完整歌曲的文件，其完整度评分不应超过1分。训练阶段，我们将仅使用完整度评分≥2分的歌曲进行“完整歌曲”生成训练；评分＜2分的，仅用于片段或单轨生成训练。
        1: 绝大多数音轨明显在MIDI文件中缺失，剩余音轨断断续续，完全无法构成完整歌曲
        2: 剩余轨道至少能构成一首连续完整的独立歌曲，主乐器（钢琴、吉他、贝斯）齐备，但配器单调，缺少商业发行曲目的丰富度
        3: 剩余音轨较为完整，保留轨道已超商业发行作品常见总数的一半，且含若干主乐器之外的附加配器
        4: 剩余音轨非常完整，保留轨道数与商业发行作品无异，乐轨丰富度达到发行水平
        5: 保留轨道数与商业发行作品无异，且配器丰富度超出平均水平，是极高质量的编曲文件
        Please evaluate, from the standpoint of the completeness of the arrangement, how this song compares to a commercially released piece. (Consider only the arrangement—exclude instrument timbres and mixing.) Since we removed a large number of tracks during preprocessing, please determine whether the remaining tracks suffice to constitute a “standalone complete song.” In principle, any file that cannot be deemed a complete song should receive a completeness score of no more than 1. During training, we will use only songs with a completeness score ≥ 2 for “full‑song” generation; songs scoring < 2 will be used solely for segment or single‑track generation.
        1: The vast majority of tracks are clearly missing from the MIDI file; the remaining tracks are fragmented, non-contiguous, and cannot form a complete piece at all.
        2: The remaining tracks can at least constitute a continuous, standalone song; core instruments (piano, guitar, bass) are present, but the arrangement is monotonous and lacks the richness of a commercial release.
        3: The remaining tracks are fairly complete: the number of remaining tracks exceed half the typical count for commercial releases and include several supplementary instruments beyond the core ones.
        4: The remaining tracks are highly complete: the number of remaining tracks is on par with that of a commercial release, and the instrumentation richness meets commercial production standards.
        5: The remaining tracks equal those of a commercial release, and the instrumentation richness surpasses the average level, making it an exceptionally high‑quality arrangement.`,
        singleSelect: true,
        mandatory: true,
    },
    // Line 9: emotion
    {
        name: "emotion",
        questionText: "Emotion (心情)",
        type: "free-response",
        fullWidth: true,
        instruction: `这首歌您认为表现了创作者怎样的心情，或者您在听的时候会产生怎样的心情。很有概括性的形容词也可以在这里回答。有可能这段音乐前后表现出不同的心情，因此您也可以填写多个心情。例如：开心、悲伤、绝望、愤怒、前半段平静，后半段撕心裂肺。
        Describe the emotions conveyed by the song or the feelings it evokes in you. You can list multiple emotions if the song changes throughout. Examples: Happy, Sad, Desperate, Angry.`,
    },
    // Line 10: imagery
    {
        name: "imagery",
        questionText: "Imagery (歌曲画面)",
        type: "free-response",
        fullWidth: true,
        instruction: `例如: 我听到了慵懒的黄昏，在古巴的沙滩上漫步，面前是海浪和温暖的夕阳的感觉。
        Examples: As I stroll along a Cuban beach, I see the lazy dusk and hear the sound of waves blending with the warmth of the sunset unfolding before me.`,
    },
    // Line 11: regional_classification, music_style
    {
        name: "regional_classification",
        questionText: "Regional Classification (地区分类)",
        type: "multiple-choice",
        items: RegionalClassificationOptions,
        allowAnyLevelSelection: true,
        singleSelect: true,
        instruction: `- 您可以根据各种这首歌的已知信息判断这首歌的地区分类并选择，或者通过听感确定这首歌的地区
如果您只能判断大致地区，但不能精细到具体国家，您也完全可以只选到地区一层
- Choose the region this song is most associated with, either based on explicit knowledge or your own auditory impression
If you can only determine the general region but not a specific country, you can select the broader category only`,
    },
    {
        name: "music_style",
        questionText: "Music Style (曲风)",
        type: "multiple-choice",
        items: MusicStyleOptions,
        allowAnyLevelSelection: true,
        mandatory: true,
        instruction: `- 本问题涉及了多层选项，您可以选择例如"迷幻摇滚"这样的子流派，如果不能确定的话也可以选择"摇滚"这样的在第一层的大流派
- 我们为您优先呈现出了子流派中综合来讲最可能需要选到的一些，例如"硬摇滚"；但您如果认为其应当是某一相对小众的子流派，例如"黑暗民谣"，则可能需要在"其他"中寻找到它
您可能会认为这段音乐是不同曲风的混搭，或者介于两种曲风之间，那么此时您可以进行多选
- This section includes multiple levels of selection
- You can choose a subgenre (e.g., "Psychedelic Rock") or, if unsure, select a broader genre (e.g., "Rock")
- The system prioritizes displaying commonly used subgenres (e.g., "Hard Rock"), but if you believe a song belongs to a more niche subgenre (e.g., "Dark Folk"), you may need to find it under the "Other" category.
If the music blends multiple styles or falls between two genres, you may select multiple options.`
    },
    // Line 12: music_style_description
    {
        name: "music_style_description",
        questionText: "Music Style Description (曲风描述)",
        type: "free-response",
        fullWidth: true,
        instruction: `用自由的语言去描述这首歌的曲风，越具体越好，可以是非专业的口头表述(如"华语大流行情歌"、"校园情歌"、"90年代港风劲曲"、"李宗盛念白式的情歌"、"R&B和黄梅戏Fusion"等)，也可以是曲风选项中不存在的小众/独特曲风(如City Pop、海盗金属等)。
        Use free and expressive language to describe the style of this song—the more specific, the better. It can be casual and non-technical (e.g., "mainstream Mandopop ballad," "school ballad," "90s Hong Kong-style Disco," "Li Zongsheng-style spoken-word love song," or "R&B and Huangmei opera fusion"). It can also be a niche or unique genre that isn't included in the style choices in the previous question (e.g., "city pop," "pirate metal").`
    },
    // Line 13: professional_description
    {
        name: "professional_description",
        questionText: "Professional Description of Full Song (对歌曲的专业描述)",
        type: "free-response",
        mandatory: true,
        fullWidth: true,
        instruction: `例如: 这是一首华语情歌，4/4拍，曲速80，D调。前奏由尼龙弦吉他弹奏分解和弦（和声 1-6-4-5，循环两遍，第二遍的 6 级改为大六），再加入钢弦吉他演奏主旋律。主歌以钢琴和吉他伴奏，钢琴注重副旋律和装饰音，同时用低音营造律动感。副歌部分自由发挥，间奏由小提琴引入弦乐，大提琴和声，第三拍加入中提琴和小提琴二部，小提琴一、二部走六度和声。间奏后半段加入鼓组，紧接着主歌进入扫弦伴奏，副歌延续自由发挥，但在第二遍时加入一个"切口"效果，制造类似综艺节目中的情绪转折。
        Examples: Write a Mandarin love song in 4/4 time, at a tempo of 80 BPM, in the key of D major. The intro features a nylon-string guitar playing broken chords (chord progression 1-6-4-5, repeated twice, with the second iteration changing the 6th chord to a 6th major). A steel-string guitar is then added to play the main melody. The verse is accompanied by piano and guitar, with the piano emphasizing secondary-melodies and embellishments while using the bass to create rhythmic movement. The chorus is open to your creative choices as an AI assistant. The interlude begins with a violin introducing the strings, supported by a cello, with the viola and second violin joining on the third beat, while the first and second violins harmonize in sixths. In the second half of the interlude, drums are introduced, leading into the verse where the guitar switches to strumming. The chorus follows as usual, but in the second iteration, a syncopation is added, creating a dramatic transition similar to those used in music TV shows.`,
    },
    // Line 14: casual_description
    {
        name: "casual_description",
        questionText: "Casual Description of Full Song (对歌曲的白话描述)",
        type: "free-response",
        mandatory: true,
        fullWidth: true,
        instruction: `- 这是一首像周杰伦《枫》一样感觉的歌，有厚重的弦乐，伴随很凄凉的氛围
- 这首歌特别适合我在咖啡馆看书的时候听，比较能让人静心，而且很轻松，钢琴的音色和旋律特别好听
这歌也太烂了，我不知道它是怎么好意思发表出来的。这个吉他的旋律简直像拿脚随机弹出来的一样。不要和我说这是实验音乐，我很确定这就是一首流行歌。
- This song is perfect for reading in a caf—it helps you stay calm, and the piano tone is really soothing.
- The drum groove is so rhythmic that it makes me want to dance or go for a run. It feels really energizing!
This song is just bad. I don't understand how they even dared to release it. The guitar melody sounds like it was randomly plucked with someone's feet. Don't tell me this is "experimental music"—I'm sure it's supposed to be a pop song.`,
    }
    ]
}

export const TimeSignatureInstruction = `- 由于很多歌曲在中间某一部分会更改拍号，我们会需要您在标注拍号时，同时标上小节数、第几拍、第几亚拍
- 例如，16:1:1代表的是第16小节的第1拍第1亚拍。如果拍号在16:1:1处发生变化，您就应该在此处添加一个新的拍号，代表这个新的拍号在此处开始生效
- 亚拍（subdivision）：我们将每拍进行细分，确保最小单位为1/16音符。
- 绝大多数情况下，拍号的变化都会发生在小节开始处，例如1:1:1、4:1:1……
您很可能可以直接通过时间轴目测出它拍号发生了变化
- Since some songs change time signatures at certain points, you need to mark the exact location of the time signature change.
- When annotating a time signature, include a position marker in the format "measure: beat: sub-beat" (e.g., 16:1:1 means the change occurs at measure 16, beat 1, sub-beat 1).
- Sub-beats: We subdivide each beat to ensure that the smallest unit is a 1/16 note.
- Most time signature changes occur at the beginning of a measure (e.g., 1:1:1, 4:1:1, etc.).
You can often visually identify time signature changes on a timeline.`

export const KeyInstruction = `如同拍号的问题一样，对曲调的标注应当在标注时添加一个如16:1:1这样的位置，代表该曲调从这里开始
Similar to time signatures, when annotating key changes, add a position marker like 16:1:1 to indicate where the key change begins.`

export const TempoInstruction = `如同拍号的问题一样，对曲速的标注应当在标注时添加一个如16:1:1这样的位置，代表该曲速从这里开始
Similar to time signature changes, tempo changes should be annotated with a position marker (e.g., 16:1:1 to indicate that the new tempo starts at measure 16, beat 1, sub-beat 1).`

export const BarLevelAnnotationInstruction = `提示1：本阶段训练仅聚焦有固定音高的乐器。预处理时已删除无固定音高或不同音源按键对应的声音没有统一定义的轨道（如部分合成器、FX、打击乐），但预处理算法经常会有遗漏。因此，若某轨道在您尝试播放时听起来是乱音、错音或噪音，请直接利用垃圾桶按键 "Mark this track for deletion (将该乐轨标记为应删除乐轨)"，且无需在该轨道上添加任何标注方块。

提示2: 在微观信息各个轨添加标注方块时，每个标注方块的位置需打开DAW(编曲软件)，严格按照DAW中的位置填写。
例如，如果某个MIDI文件有空的小节，第一个音实际在第3小节才出现，则标注时也应该把第一个标注方块添加在第3小节（而不是自作主张挪到第1小节）。

Reminder 1: In this phase of training , we focus exclusively on instruments with fixed pitch. During preprocessing, we removed tracks that lack a fixed pitch or whose key‑to‑sound mapping isn't standardized across sample libraries (e.g., certain synthesizers, FX, percussion), but the algorithm may occasionally miss some. Therefore, if a track sounds like random notes, incorrect pitches, or noise when you play it, please use the trashcan button to "Mark this track for deletion (将该乐轨标记为应删除乐轨)" and do not add any annotation blocks to that track.

Reminder 2: When adding annotation blocks to each track of the micro-level information, the position of each block must be determined by checking the DAW (digital audio workstation). Annotations must strictly follow the actual positions shown in the DAW.
For example, if a MIDI file has empty bars and the first note does not appear until measure 3, the first annotation block should also be placed at measure 3, NOT arbitrarily moved to measure 1.`
